import { Grid } from "@material-ui/core";
import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import { Typography } from "antd";
import HelpCircleIcon from "../../../images/mdi_information-outline.png";
import CloseIcon from "../../../images/notif_close.png";
import { useState } from "react";

const PositionedTooltips = ({
  title = "",
  description = "",
  showIt = false,
  disablePadding,
  overrideWeirdStyling,
  position = "above",
}: {
  title?: string;
  description?: string | React.ReactElement;
  showIt?: boolean;
  disablePadding?: boolean;
  overrideWeirdStyling?: boolean;
  position?: "above" | "below";
}): React.ReactElement => {
  let [tooltipOpen, setTooltipOpen] = useState(false);
  let [isClicked, setIsClicked] = useState(false);
  const tooltipAnchorRef = React.useRef<HTMLDivElement>(null);
  const mouseLeaveTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsClicked(true);
    setTooltipOpen(true);
  };

  const handleCloseClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setTooltipOpen(false);
    setIsClicked(false);
  };

  const handleMouseEnter = () => {
    if (mouseLeaveTimeoutRef.current) {
      clearTimeout(mouseLeaveTimeoutRef.current);
      mouseLeaveTimeoutRef.current = null;
    }
    if (!isClicked) {
      setTooltipOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isClicked) {
      mouseLeaveTimeoutRef.current = setTimeout(() => {
        setTooltipOpen(false);
      }, 200);
    }
  };

  if (showIt) {
    return (
      <Grid
        item
        container
        xs={6}
        direction="column"
        style={{
          margin: "0px",
          flexBasis: overrideWeirdStyling ? "0%" : "0%",
          flexGrow: 0,
          maxWidth: overrideWeirdStyling ? "50%" : "9%",
          position: "relative",
        }}
        ref={tooltipAnchorRef}
      >
        <Grid item style={{ position: "relative" }}>
          <IconButton
            style={{
              paddingRight: 0,
              padding: "4px",
              ...(disablePadding ? { padding: "0px" } : {}),
            }}
            onClick={handleIconClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <img src={HelpCircleIcon} alt="info" style={{ width: "24px", height: "24px" }} />
          </IconButton>

          {tooltipOpen && (
            <div
              style={{
                position: "absolute",
                ...(position === "below"
                  ? { top: "100%", marginTop: "10px" }
                  : { bottom: "100%", marginBottom: "10px" }
                ),
                right: "-30px",
                backgroundColor: "#F5F5F5",
                border: "2px dashed #CCCCCC",
                borderRadius: "8px",
                padding: "12px 16px",
                minWidth: "250px",
                zIndex: 9999,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
              onMouseEnter={() => {
                if (mouseLeaveTimeoutRef.current) {
                  clearTimeout(mouseLeaveTimeoutRef.current);
                  mouseLeaveTimeoutRef.current = null;
                }
                setTooltipOpen(true);
              }}
              onMouseLeave={() => {
                if (!isClicked) {
                  mouseLeaveTimeoutRef.current = setTimeout(() => {
                    setTooltipOpen(false);
                  }, 200);
                }
              }}
            >
              <button
                onClick={handleCloseClick}
                style={{
                  position: "absolute",
                  top: "-12px",
                  right: "-12px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "0px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "28px",
                  height: "28px",
                }}
                title="Close"
              >
                <img src={CloseIcon} alt="close" style={{ width: "24px", height: "24px" }} />
              </button>
              {title ? (
                <Typography
                  style={{
                    color: "#333333",
                    fontSize: "14px",
                    paddingBottom: "8px",
                    fontWeight: 600,
                  }}
                >
                  {title}
                </Typography>
              ) : null}
              <Typography
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.5",
                }}
              >
                {description}
              </Typography>
            </div>
          )}
        </Grid>
      </Grid>
    );
  }

  return <div></div>;
};
export default PositionedTooltips;
